import { Button, Modal, Table } from "antd";
import { useState } from "react";
import { useGetAllFeedCommentAdminByFeedId } from "../../model";
import { ColumnsType } from "antd/es/table";
import dayjs from "dayjs";
import FeedCommentManageModal from "../../../feedCommentManage/ui/modal";

interface IProps {
    feedId: number
    btnText?: string
}

const FeedManageDetailFeedCommentModal = ({ feedId, btnText }: IProps) => {
    const [open, setOpen] = useState<boolean>(false);
    const responseQuery = 'id nickName content createdDate feedCommentHiddenId isHidden feedId reason status totalClaimCnt';
    const { data, isPending } = useGetAllFeedCommentAdminByFeedId<IFeedCommentAdminResponse[]>(feedId, responseQuery, open)

    const feedCommentColumns: ColumnsType<IFeedCommentAdminResponse> = [
        {
            title: '닉네임',
            dataIndex: 'nickName',
        },
        {
            title: '작성일시',
            dataIndex: 'createdDate',
            render: q => dayjs(q).format('YYYY.MM.DD HH:mm'),
            sorter: (a, b) => dayjs(b.createdDate).diff(dayjs(a.createdDate))
        },
        {
            title: '내용',
            dataIndex: 'content',
        },
        {
            title: '노출/숨길',
            dataIndex: 'isHidden',
            render: q => (q === undefined || q === null) ? '미처리' : q ? '숨김' : '노출'
        },
        {
            title: '신고횟수',
            dataIndex: 'totalClaimCnt',
            render: q => q ? q : 0,
            sorter: (a, b) => a.totalClaimCnt ? b.totalClaimCnt ? b.totalClaimCnt - a.totalClaimCnt : 1 : 1
        },
        {
            title: '댓글 관리',
            dataIndex: 'id',
            render: q => <FeedCommentManageModal feedCommentId={q} />
        }
    ]
    return <>
        <Button onClick={() => setOpen(true)}>
            {btnText ?? '댓글 관리'}
        </Button>

        <Modal width={700} centered title='댓글 관리' open={open} onCancel={() => setOpen(false)} onClose={() => setOpen(false)} footer={null}>
            <div style={{ marginBlock: '24px' }}>
                <div style={{ fontSize: '12px', fontWeight: 700 }}>
                    댓글 수 : {data?.length}개
                </div>
                <Table dataSource={data} rowKey={'id'} columns={feedCommentColumns} pagination={{ showSizeChanger: true }} loading={isPending} />
            </div>
        </Modal>
    </>
}

export default FeedManageDetailFeedCommentModal;